import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/images/portal_logo.png';
const _withScopeId = n => (_pushScopeId("data-v-145a9104"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _createStaticVNode("<img src=\"" + _imports_0 + "\" data-v-145a9104><div class=\"p-4\" data-v-145a9104><div class=\"infoNote\" data-v-145a9104><p data-v-145a9104>This site is for caseworkers / partners to access Mini City services.</p><p class=\"pt-1 has-text-weight-bold\" data-v-145a9104>To sign up homeless citizens, please use <a class=\"infoLink\" href=\"https://my.minicityatl.com\" data-v-145a9104>my.minicityatl.com</a>.</p></div></div>", 2);
const _hoisted_3 = { class: "field pt-5" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Email", -1));
const _hoisted_5 = { class: "control is-large" };
const _hoisted_6 = { class: "field" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Password", -1));
const _hoisted_8 = { class: "control is-large" };
const _hoisted_9 = { class: "field pt-3" };
const _hoisted_10 = { class: "control is-large" };
const _hoisted_11 = ["disabled"];
const _hoisted_12 = ["disabled"];
const _hoisted_13 = {
    key: 0,
    class: "notification bulmaNotification is-warning"
};
const _hoisted_14 = {
    key: 1,
    class: "notification bulmaNotification is-danger"
};
const _hoisted_15 = {
    key: 2,
    class: "notification bulmaNotification is-danger mt-6"
};
const _hoisted_16 = { class: "mb-2" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Enter the current 6-digit code displayed within the app:", -1));
const _hoisted_18 = {
    key: 0,
    style: { "text-align": "center" }
};
const _hoisted_19 = {
    key: 1,
    class: "columns is-loading"
};
import { reactive, getCurrentInstance } from "vue";
import { useRoute } from "vue-router";
import { loginAsNetworkAdmin, initiatePasswordReset, loginAsAnyUser } from "@/core/session";
import { mapHttpError, notifyError, notifyNetworkError, notifySuccess } from "@/core/utils";
import { CONFIG, MaintenanceMode } from "@/core/config";
import { useValidation, Validations } from "@/composables/useValidation";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Login',
    setup(__props) {
        const instance = getCurrentInstance();
        const mfaValidation = useValidation();
        const forwardTo = useRoute().query.forwardTo;
        const postLoginURL = (forwardTo === null || forwardTo === void 0 ? void 0 : forwardTo.length) ? forwardTo.toString() : '/';
        const loginState = reactive({
            email: "",
            password: "",
            displayMfaPrompt: false,
            mfaOneTimeCode: "",
            inProgress: false,
            loggingInAsNetworkAdmin: false,
            error: "",
            isAutoLogout: useRoute().query.autoLogout == 'true'
        });
        const login = (asNetworkAdmin, mfaOneTimeCode) => {
            loginState.loggingInAsNetworkAdmin = asNetworkAdmin;
            loginState.isAutoLogout = false;
            loginState.error = "";
            loginState.inProgress = true;
            loginState.displayMfaPrompt = false;
            let loginFunc = asNetworkAdmin ? loginAsNetworkAdmin : loginAsAnyUser;
            loginFunc(loginState.email, loginState.password, mfaOneTimeCode)
                .then(sess => {
                instance.proxy.$router.push(postLoginURL);
            })
                .catch(err => {
                let errorMessage = mapHttpError(err).message;
                if (errorMessage == "Expected MFA code") {
                    showMFAPrompt();
                }
                else {
                    loginState.error = mapHttpError(err).message;
                }
            })
                .finally(() => {
                loginState.inProgress = false;
            });
        };
        const looksLikeNetworkAdminLogin = () => {
            return loginState.email.trim().endsWith(`@${CONFIG.value.adminEmailDomain}`);
        };
        const showMFAPrompt = () => {
            loginState.displayMfaPrompt = true;
            loginState.mfaOneTimeCode = "";
        };
        const loginWithMFA = () => {
            if (!mfaValidation.areAllFieldsValid)
                return;
            login(loginState.loggingInAsNetworkAdmin, loginState.mfaOneTimeCode);
        };
        const isFormValid = () => {
            return (Validations.notEmpty(loginState.email) && Validations.email(loginState.email) && Validations.notEmpty(loginState.password));
        };
        const passwordResetState = reactive({
            inProgress: false,
            shown: false,
            email: "",
        });
        const resetPassword = () => {
            passwordResetState.shown = true;
            passwordResetState.email = loginState.email;
        };
        const doResetPassword = () => {
            if (!(Validations.notEmpty(passwordResetState.email) && Validations.email(passwordResetState.email))) {
                notifyError("Please specify a valid email address");
                return;
            }
            passwordResetState.inProgress = true;
            initiatePasswordReset(passwordResetState.email)
                .then(() => {
                notifySuccess("Please check your inbox for a link to reset your password!");
                passwordResetState.shown = false;
            })
                .catch(err => notifyNetworkError("Failed to reset password", err))
                .finally(() => passwordResetState.inProgress = false);
        };
        return (_ctx, _cache) => {
            const _component_LoadingPage = _resolveComponent("LoadingPage");
            const _component_FormTextField = _resolveComponent("FormTextField");
            const _component_ModalDialog = _resolveComponent("ModalDialog");
            const _component_LoadingSpinner = _resolveComponent("LoadingSpinner");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (loginState.inProgress)
                    ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
                    : (_openBlock(), _createElementBlock("form", {
                        key: 1,
                        class: "fullscreenCenteredContainer",
                        onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => { }, ["prevent"]))
                    }, [
                        _hoisted_1,
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    placeholder: "Email",
                                    class: _normalizeClass(["input is-large", { 'is-danger': loginState.error.length > 0 }]),
                                    autofocus: "",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((loginState.email) = $event))
                                }, null, 2), [
                                    [_vModelText, loginState.email]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _hoisted_7,
                            _createElementVNode("div", _hoisted_8, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "password",
                                    placeholder: "Password",
                                    class: _normalizeClass(["input is-large", { 'is-danger': loginState.error.length > 0 }]),
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((loginState.password) = $event))
                                }, null, 2), [
                                    [_vModelText, loginState.password]
                                ])
                            ]),
                            _createElementVNode("a", {
                                class: "forgotPasswordLink",
                                onClick: _cache[2] || (_cache[2] = ($event) => (resetPassword()))
                            }, "Forgot your password?")
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                (looksLikeNetworkAdminLogin())
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "submit",
                                        class: "button is-link is-large mr-2",
                                        disabled: !isFormValid(),
                                        onClick: _cache[3] || (_cache[3] = ($event) => (login(true)))
                                    }, "Login As Admin", 8, _hoisted_11))
                                    : _createCommentVNode("", true),
                                (_unref(CONFIG).maintenanceMode == _unref(MaintenanceMode).OPEN)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "submit",
                                        class: "button is-link is-large",
                                        disabled: !isFormValid(),
                                        onClick: _cache[4] || (_cache[4] = ($event) => (login(false)))
                                    }, "Login", 8, _hoisted_12))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        (_unref(CONFIG).maintenanceMessage && _unref(CONFIG).maintenanceMessage.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(CONFIG).maintenanceMessage), 1))
                            : _createCommentVNode("", true),
                        (loginState.error.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(loginState.error), 1))
                            : _createCommentVNode("", true),
                        (loginState.isAutoLogout)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, "You have been automatically logged-out due to inactivity"))
                            : _createCommentVNode("", true)
                    ], 32)),
                _createVNode(_component_ModalDialog, {
                    active: loginState.displayMfaPrompt,
                    title: "Multi-Factor Authentication",
                    severity: "info",
                    allowClose: true,
                    onClose: _cache[8] || (_cache[8] = ($event) => (loginState.displayMfaPrompt = false)),
                    firstButtonText: "Login",
                    firstButtonSeverity: "primary",
                    onFirstbuttonselected: _cache[9] || (_cache[9] = ($event) => (loginWithMFA()))
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_16, [
                            _hoisted_17,
                            _createVNode(_component_FormTextField, {
                                label: "MFA code",
                                modelValue: loginState.mfaOneTimeCode,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((loginState.mfaOneTimeCode) = $event)),
                                validator: _unref(mfaValidation).validator(_unref(Validations).digits, _unref(Validations).length(6)),
                                onEnter: _cache[7] || (_cache[7] = ($event) => (loginWithMFA())),
                                autoFocus: ""
                            }, null, 8, ["modelValue", "validator"])
                        ])
                    ]),
                    _: 1
                }, 8, ["active"]),
                _createVNode(_component_ModalDialog, {
                    active: passwordResetState.shown,
                    title: "Reset Password",
                    "allow-close": true,
                    onClose: _cache[11] || (_cache[11] = ($event) => (passwordResetState.shown = false)),
                    "first-button-text": "Go Back",
                    "first-button-severity": "link",
                    onFirstbuttonselected: _cache[12] || (_cache[12] = ($event) => (passwordResetState.shown = false)),
                    "second-button-text": "Reset",
                    "second-button-severity": "primary",
                    onSecondbuttonselected: _cache[13] || (_cache[13] = ($event) => (doResetPassword()))
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", null, [
                            (passwordResetState.inProgress)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createVNode(_component_LoadingSpinner, { size: "medium" })
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createVNode(_component_FormTextField, {
                                        label: "Please enter your email address to reset your password",
                                        placeholder: "Email",
                                        modelValue: passwordResetState.email,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((passwordResetState.email) = $event))
                                    }, null, 8, ["modelValue"])
                                ]))
                        ])
                    ]),
                    _: 1
                }, 8, ["active"])
            ], 64));
        };
    }
});
